// filters.js
export const getSharedFilters = () => {
    return JSON.parse(localStorage.getItem("fourPageFilters")) || {
      weekly: "",
      month: "",
      shift: ""
    };
  };
  
  export const updateSharedFilters = (newFilters) => {
    localStorage.setItem("fourPageFilters", JSON.stringify(newFilters));
  };
  